import { graphql, Link, useStaticQuery } from "gatsby"
import React from "react"
import { Col, Row } from "react-bootstrap"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const RelatedPosts = ({ category }) => {
  const query = graphql`
    {
      allStrapiBlogs(sort: { fields: date, order: ASC }) {
        group(field: category, limit: 3) {
          nodes {
            slug
            Image {
              localFile {
                childImageSharp {
                  gatsbyImageData(placeholder: BLURRED)
                }
              }
            }
            category
            title
          }
        }
      }
    }
  `
  const data = useStaticQuery(query)
  const {
    allStrapiBlogs: { group },
  } = data

  const catArr = group.map(item => item.nodes).flat()

  const ans = catArr.filter(item => item.category === category)

  return (
    <div className="popular-posts my-5">
      <h1 className="rb r-h1 text-start">Related Posts</h1>
      <Row>
        {ans.map((item, i) => {
          const path = getImage(item.Image.localFile)
          return (
            <Col lg={4} md={6} xs={6} key={i} className="p-items">
              <Link to={`/blog/${item.category}/${item.slug}`}>
                <GatsbyImage image={path} alt={item.title} className="my-3" />
              </Link>
              <Link to={`/blog/${item.category}`}>
                <p className="my-2 cat">{item.category}</p>
              </Link>
              <Link to={`/blog/${item.category}/${item.slug}`}>
                <h1 className="rb">{item.title}</h1>
              </Link>
            </Col>
          )
        })}
      </Row>
    </div>
  )
}

export default RelatedPosts
